import React from 'react';
import { Card } from '../components/UI/Card';
export const NetworkingGuide = () => {
  const steps = [{
    number: '1️⃣',
    title: 'Set Your Compass – What Do You Want?',
    content: <div className="space-y-4" data-id="element-3933">
          <p data-id="element-3934">Instead of "I must network more," ask:</p>
          <ul className="space-y-2" data-id="element-3935">
            <li className="flex items-start" data-id="element-3936">
              <span className="mr-2" data-id="element-3937">🔍</span>
              <span data-id="element-3938">What excites me about connecting with others?</span>
            </li>
            <li className="flex items-start" data-id="element-3939">
              <span className="mr-2" data-id="element-3940">🎯</span>
              <span data-id="element-3941">
                Am I seeking mentorship, collaboration, opportunities, or just
                inspiration?
              </span>
            </li>
            <li className="flex items-start" data-id="element-3942">
              <span className="mr-2" data-id="element-3943">💎</span>
              <span data-id="element-3944">What unique value do I bring into a conversation?</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-3945">
            <span className="mr-2" data-id="element-3946">✍️</span>
            <span data-id="element-3947">
              Exercise: Write 3 things you hope to gain from networking — and 3
              things you can give.
            </span>
          </p>
        </div>
  }, {
    number: '2️⃣',
    title: 'Design Your Introduction (Your Story in 30 Seconds)',
    content: <div className="space-y-4" data-id="element-3948">
          <p data-id="element-3949">
            Networking starts with clarity. But clarity doesn't mean rigidity.
          </p>
          <ul className="space-y-2" data-id="element-3950">
            <li className="flex items-start" data-id="element-3951">
              <span className="mr-2" data-id="element-3952">👤</span>
              <span data-id="element-3953">Who am I? (roles, passions, projects)</span>
            </li>
            <li className="flex items-start" data-id="element-3954">
              <span className="mr-2" data-id="element-3955">🌱</span>
              <span data-id="element-3956">What drives me? (purpose, values, interests)</span>
            </li>
            <li className="flex items-start" data-id="element-3957">
              <span className="mr-2" data-id="element-3958">🔗</span>
              <span data-id="element-3959">Who do I want to connect with right now?</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-3960">
            <span className="mr-2" data-id="element-3961">🎤</span>
            <span data-id="element-3962">
              Activity: Draft 2-3 "micro-intros" you can switch between (for
              events, LinkedIn, casual chats).
            </span>
          </p>
        </div>
  }, {
    number: '3️⃣',
    title: 'Choose Your Arena – Where Will You Play?',
    content: <div className="space-y-4" data-id="element-3963">
          <p data-id="element-3964">Networking happens everywhere:</p>
          <ul className="space-y-2" data-id="element-3965">
            <li className="flex items-start" data-id="element-3966">
              <span className="mr-2" data-id="element-3967">🎙</span>
              <span data-id="element-3968">Events & salons</span>
            </li>
            <li className="flex items-start" data-id="element-3969">
              <span className="mr-2" data-id="element-3970">📩</span>
              <span data-id="element-3971">DMs & email outreach</span>
            </li>
            <li className="flex items-start" data-id="element-3972">
              <span className="mr-2" data-id="element-3973">🌍</span>
              <span data-id="element-3974">Online communities & forums</span>
            </li>
            <li className="flex items-start" data-id="element-3975">
              <span className="mr-2" data-id="element-3976">☕</span>
              <span data-id="element-3977">Coffee chats</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-3978">
            <span className="mr-2" data-id="element-3979">🧭</span>
            <span data-id="element-3980">
              Prompt: Where do you already feel most comfortable starting? Where
              do you want to stretch yourself?
            </span>
          </p>
        </div>
  }, {
    number: '4️⃣',
    title: 'Practice the First Move',
    content: <div className="space-y-4" data-id="element-3981">
          <p data-id="element-3982">Instead of waiting for serendipity, design it.</p>
          <ul className="space-y-2" data-id="element-3983">
            <li data-id="element-3984">
              <strong data-id="element-3985">Warm path:</strong> Ask someone you know for an intro.
            </li>
            <li data-id="element-3986">
              <strong data-id="element-3987">Curious path:</strong> Reach out with a thoughtful
              question.
            </li>
            <li data-id="element-3988">
              <strong data-id="element-3989">Bold path:</strong> DM someone you admire with a specific
              compliment or idea.
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-3990">
            <span className="mr-2" data-id="element-3991">💡</span>
            <span data-id="element-3992">
              Challenge: This week, make 2 connections: one warm intro, one bold
              outreach.
            </span>
          </p>
        </div>
  }, {
    number: '5️⃣',
    title: 'Build Trust, Not Just Contacts',
    content: <div className="space-y-4" data-id="element-3993">
          <p data-id="element-3994">Think about conversations as bridges, not transactions.</p>
          <ul className="space-y-2" data-id="element-3995">
            <li className="flex items-start" data-id="element-3996">
              <span className="mr-2" data-id="element-3997">👂</span>
              <span data-id="element-3998">Listen deeply.</span>
            </li>
            <li className="flex items-start" data-id="element-3999">
              <span className="mr-2" data-id="element-4000">🎁</span>
              <span data-id="element-4001">
                Offer something of value (resource, insight, connection).
              </span>
            </li>
            <li className="flex items-start" data-id="element-4002">
              <span className="mr-2" data-id="element-4003">🔄</span>
              <span data-id="element-4004">
                Follow up quickly with gratitude + a simple next step.
              </span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4005">
            <span className="mr-2" data-id="element-4006">✨</span>
            <span data-id="element-4007">
              Reflection: Recall the last time someone made you feel heard. How
              can you replicate that in your networking?
            </span>
          </p>
        </div>
  }, {
    number: '6️⃣',
    title: 'Keep the Web Alive',
    content: <div className="space-y-4" data-id="element-4008">
          <p data-id="element-4009">A network is like a garden — it needs tending.</p>
          <ul className="space-y-2" data-id="element-4010">
            <li className="flex items-start" data-id="element-4011">
              <span className="mr-2" data-id="element-4012">🌱</span>
              <span data-id="element-4013">Share updates about your journey.</span>
            </li>
            <li className="flex items-start" data-id="element-4014">
              <span className="mr-2" data-id="element-4015">🎉</span>
              <span data-id="element-4016">Celebrate others' wins.</span>
            </li>
            <li className="flex items-start" data-id="element-4017">
              <span className="mr-2" data-id="element-4018">🔗</span>
              <span data-id="element-4019">Connect people to each other.</span>
            </li>
            <li className="flex items-start" data-id="element-4020">
              <span className="mr-2" data-id="element-4021">📒</span>
              <span data-id="element-4022">
                Track relationships (Notion, Airtable, CRM, even your Notes
                app).
              </span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4023">
            <span className="mr-2" data-id="element-4024">🛠</span>
            <span data-id="element-4025">
              Action: Create your personal "Connection Tracker" — 5 people to
              re-engage with this month.
            </span>
          </p>
        </div>
  }, {
    number: '7️⃣',
    title: 'Your Rules, Your Rhythm',
    content: <div className="space-y-4" data-id="element-4026">
          <p data-id="element-4027">
            Forget the idea that networking = constant hustle. It's about
            finding your rhythm:
          </p>
          <ul className="space-y-2" data-id="element-4028">
            <li data-id="element-4029">
              <strong data-id="element-4030">Monthly:</strong> New introductions.
            </li>
            <li data-id="element-4031">
              <strong data-id="element-4032">Weekly:</strong> Small touchpoints.
            </li>
            <li data-id="element-4033">
              <strong data-id="element-4034">Daily:</strong> One authentic conversation.
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4035">
            <span className="mr-2" data-id="element-4036">📓</span>
            <span data-id="element-4037">
              Design Your Rhythm: What feels sustainable and energizing for you?
            </span>
          </p>
        </div>
  }];
  return <div className="pt-20" data-id="element-4038">
      <section className="py-16 bg-secondary/5" data-id="element-4039">
        <div className="container mx-auto px-4" data-id="element-4040">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-4041">
            🌐 The Networking Guide: Build Connections That Matter
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-4042">
            This is not a rulebook. It's a playground for you to explore how you
            connect, what feels authentic, and where you want your network to
            take you.
          </p>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto mt-4" data-id="element-4043">
            You'll find reflection prompts, mini-experiments, and action
            challenges — designed so you shape your own networking style.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-4044">
        <div className="container mx-auto px-4" data-id="element-4045">
          <div className="space-y-12" data-id="element-4046">
            {steps.map((step, index) => <Card key={index} className="p-6 border-2 border-gray-200" data-id="element-4047">
                <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-4048">
                  <div className="text-3xl font-bold text-primary" data-id="element-4049">
                    {step.number}
                  </div>
                  <div className="flex-1" data-id="element-4050">
                    <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-4051">
                      {step.title}
                    </h2>
                    <div className="text-secondary" data-id="element-4052">{step.content}</div>
                  </div>
                </div>
              </Card>)}
            <Card className="p-6 border-2 border-gray-200" data-id="element-4053">
              <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-4054">
                ⚡ Quick Experiments (Choose Your Path)
              </h2>
              <div className="space-y-4" data-id="element-4055">
                <p className="flex items-start" data-id="element-4056">
                  <span className="mr-2 text-xl" data-id="element-4057">🎭</span>
                  <span data-id="element-4058">
                    <strong data-id="element-4059">The Actor's Game:</strong> Try introducing yourself
                    3 different ways in one week. Notice what lands.
                  </span>
                </p>
                <p className="flex items-start" data-id="element-4060">
                  <span className="mr-2 text-xl" data-id="element-4061">📩</span>
                  <span data-id="element-4062">
                    <strong data-id="element-4063">The 5-Message Sprint:</strong> Send 5 personalized
                    messages in 5 days. Track replies.
                  </span>
                </p>
                <p className="flex items-start" data-id="element-4064">
                  <span className="mr-2 text-xl" data-id="element-4065">☕</span>
                  <span data-id="element-4066">
                    <strong data-id="element-4067">The Coffee Challenge:</strong> Book 2 chats with
                    people outside your usual circle this month.
                  </span>
                </p>
              </div>
              <p className="mt-6 font-medium" data-id="element-4068">
                👉 By the end of this guide, you don't just "learn how to
                network." You invent your own networking practice — one that
                feels natural, generous, and effective.
              </p>
            </Card>
          </div>
        </div>
      </section>
    </div>;
};